import { object, oneOf } from "prop-types";

import { getSettings } from "utils/settings";

function Logo({ style, variant }) {
  const logoSettings = getSettings("logo", {});

  const companyLogos = {
    imagotipo: logoSettings?.isotipo,
    "imagotipo-horizontal": logoSettings?.light,
    "imagotipo-horizontal-dark": logoSettings?.dark,
  };

  const src =
    companyLogos[variant] || companyLogos["imagotipo-horizontal-dark"];

  const baseStyle = {
    display: "block",
    width: "auto",
    height: "auto",
    maxWidth: variant === "imagotipo" ? "64px" : "260px",
    maxHeight: variant === "imagotipo" ? "64px" : "80px",
    objectFit: "contain",
  };

  return (
    <img
      alt="Company logo"
      src={src}
      style={{
        ...baseStyle,
        ...style,
      }}
    />
  );
}

Logo.defaultProps = {
  style: {},
  variant: "imagotipo-horizontal-dark",
};

Logo.propTypes = {
  style: object,
  variant: oneOf([
    "imagotipo",
    "imagotipo-horizontal",
    "imagotipo-horizontal-dark",
  ]),
};

export default Logo;
